const BASE_LICENSE_MANAGEMENT = '/license-management'

export const paths = {
  BASE_LICENSE_MANAGEMENT,
  ASSIGNED_LICENSES: `${BASE_LICENSE_MANAGEMENT}/assigned-licenses`,
  UNASSIGNED_LICENSES: `${BASE_LICENSE_MANAGEMENT}/unassigned-licenses`,
  EXPIRED_LICENSES: `${BASE_LICENSE_MANAGEMENT}/expired-licenses`,
  INACTIVE_LICENSES: `${BASE_LICENSE_MANAGEMENT}/inactive-licenses`,
  ASSIGN_LICENSE: `${BASE_LICENSE_MANAGEMENT}/assign-license`,
  USER_MANAGEMENT: '/user-management/:siteId?',
  TRAINING_REPORT_SITE: '/training-report/:siteId',
  TRAINING_REPORT_SLUG_SITEID: '/training-report/:reportSlug/:siteId',
  TRAINING_REPORT_SLUG: '/training-report/:reportSlug',
  EXPIRED_LICENSE_INSTRUCTIONS:
    'https://support.secondstep.org/hc/en-us/articles/7704410319899-How-do-I-renew-my-Second-Step-licenses',
}
